@if (chosenFile === null) {
  <input #fileInput hidden="true" type="file" name="file" onclick="this.value = null" (change)="fileInputChanged($event)" [accept]="acceptedFileTypesString" />
  <button mat-flat-button color="primary" (click)="fileInput.click()" translate="COMMON.CHOOSE_A_FILE" type="button"></button>
} @else {
  <div class="file-name-container">
    <button mat-icon-button color="warn" type="button" (click)="removeFile()" [matTooltip]="'COMMON.REMOVE' | translate">
      <mat-icon>close</mat-icon>
    </button>
    {{ chosenFile.name }} ({{ chosenFile.size | filesize }})
  </div>
  @if (isUploading) {
    <app-spinner size="medium"></app-spinner>
  }
}
